module.exports = __webpack_public_path__ + "img/logo_ft_horizontal_transparent.ad966cd3.png";